<template><div><dt-notice
  kind="warning"
  :hideClose="true"
  class="d-wmx100p"
>
  <template #default>
    <p class="d-body--md-compact">Before applying a typography utility, first consider using <router-link class="d-fw-semibold d-link d-link--muted" to="/design/typography/">Dialtone's text styles</router-link> that bundles Font family, Font weight, Font size, and Line height together.</p>
  </template>
</dt-notice>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-fw-{n}</code> to change an element's font-weight.</p>
<code-well-header>
  <div class="d-d-grid d-g16 d-ai-center" style="grid-template-columns: 11rem 1fr">
    <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-normal</div>
    <div><p class="d-fw-normal">The quick brown fox jumps over the lazy dog.</p></div>
    <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-medium</div>
    <div><p class="d-fw-medium">The quick brown fox jumps over the lazy dog.</p></div>
    <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-semibold</div>
    <div><p class="d-fw-semibold">The quick brown fox jumps over the lazy dog.</p></div>
    <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-bold</div>
    <div><p class="d-fw-bold">The quick brown fox jumps over the lazy dog.</p></div>
  </div>
</code-well-header>
<div class="language-html" data-highlighter="prismjs" data-ext="html"><pre v-pre><code class="language-html"><span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>p</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>d-fw-normal<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>p</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>p</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>d-fw-medium<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>p</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>p</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>d-fw-semibold<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>p</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>p</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>d-fw-bold<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>p</span><span class="token punctuation">></span></span></span>
<span class="line"></span></code></pre>
</div><h2 id="variables" tabindex="-1" class="d-docsite--header-2">Variables <a class="header-anchor d-link d-docsite--link d-link" href="#variables" aria-hidden="true">#</a></h2>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-t0">
          <tr>
              <th scope="col" class="d-p0 d-bbw0"><div class="d-p16 d-bb d-bc-default d-bbw1">Variable</div></th>
              <th scope="col" class="d-p0 d-bbw0"><div class="d-p16 d-bb d-bc-default d-bbw1">Output</div></th>
          </tr>
      </thead>
      <tbody>
        <tr v-for="{ name, output } in weight">
          <th scope="row" class="d-code--sm d-docsite-code">var(--dt-font-weight-{{ name }})</th>
          <td class="d-code--sm">{{ output }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ name, class: className, output } in weight">
        <th scope="row" class="d-code--sm d-docsite-code">
          .d-fw-{{ className }}
        </th>
        <td class="d-code--sm">
          font-weight: var(--dt-font-weight-{{ name }}) !important;
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { weight } from '@data/type.json';
  import ClampedTableWrapper from '@baseComponents/ClampedTableWrapper.vue';
</script>